import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "flex items-center justify-between mb-2" }
const _hoisted_3 = { class: "text-teal-400 font-medium" }
const _hoisted_4 = { class: "h-3 w-full bg-white/10 rounded-full overflow-hidden" }




export default /*@__PURE__*/_defineComponent({
  __name: 'ConversionBar',
  props: {
    conversionRate: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-sm text-gray-400" }, "Taxa de Conversão", -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.conversionRate) + "%", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "h-full bg-gradient-to-r from-teal-600 to-teal-400",
        style: _normalizeStyle({ width: `${_ctx.conversionRate}%` })
      }, null, 4)
    ])
  ]))
}
}

})